import styled, { css } from 'styled-components';

const StickyFooter = styled.div((props) => {
  return css`
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    background: ${props.theme.brand.background.primary};
    box-shadow: ${props.theme.shadow.primary};
  `;
});

export { StickyFooter };
